import React, { forwardRef, memo } from 'react';
import classNames from 'classnames/bind';
import { Card } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
import { ServiceHeader } from "./components/ServiceHeader";
import { ServiceContent } from "./components/ServiceContent";
var cn = classNames.bind(styles);
export var ServiceTile = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$price = _ref.price,
    price = _ref$price === void 0 ? {
      value: '',
      unit: ''
    } : _ref$price,
    href = _ref.href,
    className = _ref.className,
    img = _ref.img,
    title = _ref.title,
    tag = _ref.tag,
    subtitle = _ref.subtitle,
    note = _ref.note,
    onLinkClick = _ref.onLinkClick;
  return /*#__PURE__*/React.createElement("a", {
    className: cn('link'),
    href: href,
    onClick: onLinkClick,
    ref: ref,
    "data-t-id": "components-ServiceTile"
  }, /*#__PURE__*/React.createElement(Card, {
    className: className,
    withHover: true
  }, /*#__PURE__*/React.createElement(ServiceHeader, {
    img: img,
    tag: tag,
    "data-t-id": "components-ServiceTile"
  }), /*#__PURE__*/React.createElement(ServiceContent, {
    note: note,
    price: price,
    subtitle: subtitle,
    title: title
  })));
}));